/**
 * Выбор облика героя: три аватара, один выбран.
 *
 * Назначение файла: дать игроку сменить внешний вид героя. Выбор — косметика и
 * хранится в настройках устройства (`hive.ui.prefs.v1`), поэтому кнопки ничего
 * не отправляют на сервер и работают в офлайне.
 */

import { useTranslation } from "react-i18next";

import { HERO_APPEARANCES, type HeroAppearanceId } from "../../game/appearance.js";

export interface AppearancePickerProps {
  readonly value: HeroAppearanceId;
  readonly onChange: (next: HeroAppearanceId) => void;
}

export function AppearancePicker({
  value,
  onChange,
}: AppearancePickerProps): React.JSX.Element {
  const { t } = useTranslation("hero");

  return (
    <div
      className="appearance"
      role="radiogroup"
      aria-label={t("appearance.title")}
    >
      <p className="appearance__title">{t("appearance.title")}</p>
      <div className="appearance__row">
        {HERO_APPEARANCES.map((appearance) => {
          const selected = appearance.id === value;
          return (
            <button
              key={appearance.id}
              type="button"
              role="radio"
              aria-checked={selected}
              className={
                selected ? "appearance__item appearance__item--on" : "appearance__item"
              }
              onClick={() => onChange(appearance.id)}
            >
              <img
                className="appearance__face"
                src={appearance.avatar}
                alt=""
                width={192}
                height={192}
                loading="lazy"
                decoding="async"
              />
              <span className="appearance__name">{t(`appearance.${appearance.id}`)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
